module.exports = __webpack_public_path__ + "static/media/logotopaz.4332436e.png";